import { render } from "./TermsView.vue?vue&type=template&id=66ea3e1a&scoped=true"
const script = {}

import "./TermsView.vue?vue&type=style&index=0&id=66ea3e1a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ea3e1a"]])

export default __exports__